import { gql } from "@apollo/client";

export const ProductivityNumbers = gql`
  query productivityNumbers($currentDate: String, $service: String) {
    productivityNumbers(currentDate: $currentDate, service: $service)
  }
`;
